export function slugify(str) {
  const a =
    'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìıİłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;';
  const b =
    'aaaaaaaaaacccddeeeeeeeegghiiiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------';
  const p = new RegExp(a.split('').join('|'), 'g');

  if (str !== undefined)
    return str
      .toString()
      .toLowerCase()
      .replace(/\s+/g, '-') // Replace spaces with -
      .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
      .replace(/&/g, '-and-') // Replace & with 'and'
      .replace(/[^\w\-]+/g, '') // Remove all non-word characters
      .replace(/\-\-+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, ''); // Trim - from end of text
}
export function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function toLowercase(str) {
  return str.toLowerCase();
}

export function Fetcher() {
  return (...args) => fetch(...args).then((res) => res.json());
}

export function toTitleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

export function getTodaysDate() {
  // Use UTC to ensure consistent server/client rendering
  const today = new Date();
  return today.toISOString().split('T')[0];
}

export function formatDate(date) {
  // Parse date string directly to avoid timezone shifts between server/client
  // Date strings like "2025-01-15" should display as Jan 15, 2025 regardless of timezone
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  // If it's a string in YYYY-MM-DD format, parse it directly
  if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}/.test(date)) {
    const parts = date.split('T')[0].split('-');
    const year = parseInt(parts[0], 10);
    const monthIndex = parseInt(parts[1], 10) - 1;
    const day = parseInt(parts[2], 10);
    return `${months[monthIndex]} ${day}, ${year}`;
  }

  // Fallback for Date objects or other formats
  const d = new Date(date);
  const month = months[d.getUTCMonth()];
  const day = d.getUTCDate();
  const year = d.getUTCFullYear();
  return `${month} ${day}, ${year}`;
}

export function getDateMonth(date) {
  // Parse date string directly to avoid timezone shifts
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}/.test(date)) {
    const monthIndex = parseInt(date.split('T')[0].split('-')[1], 10) - 1;
    return months[monthIndex];
  }

  const d = new Date(date);
  return months[d.getUTCMonth()];
}

export function getDateDay(date) {
  // Parse date string directly to avoid timezone shifts
  if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}/.test(date)) {
    return parseInt(date.split('T')[0].split('-')[2], 10);
  }

  const d = new Date(date);
  return d.getUTCDate();
}

export function formatPhoneNumber(phoneNumberString) {
  let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3];
  }
  return null;
}

export function transformObj(obj, replacer) {
  if (obj && Object.getPrototypeOf(obj) === Object.prototype) {
    return Object.fromEntries(
      Object.entries(obj).map(([k, v]) => [replacer[k] || k, transformObj(v)])
    );
  }
  //Base case, if not an Object literal return value as is
  return obj;
}

export function compare(property, first, second) {
  let sortOrder = 1;
  if (property[0] === first) {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    let result =
      a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
}

export function cleanNPSContent(html) {
  if (!html) return '';

  // Import sanitization (dynamic import for SSR compatibility)
  const { sanitizeHTML } = require('./sanitize');

  // First, sanitize the HTML to remove XSS risks
  let cleaned = sanitizeHTML(html);

  // Remove Microsoft Office specific attributes
  cleaned = cleaned.replace(/\s*mso-[^=]*=["'][^"']*["']/gi, '');

  // Remove ALL style attributes (this handles all inline styles including font-family, font-size, etc.)
  cleaned = cleaned.replace(/\s*style\s*=\s*["'][^"']*["']/gi, '');

  // Remove any remaining Microsoft Office language attributes
  cleaned = cleaned.replace(/\s*lang\s*=\s*["'][^"']*["']/gi, '');
  cleaned = cleaned.replace(/\s*xml:lang\s*=\s*["'][^"']*["']/gi, '');

  // Remove empty span tags
  cleaned = cleaned.replace(/<span\s*>\s*<\/span>/gi, '');
  cleaned = cleaned.replace(/<span[^>]*>\s*<\/span>/gi, '');

  // Remove span tags that only contain text (unwrap them)
  // But preserve spans that contain other HTML elements
  cleaned = cleaned.replace(/<span>([^<]*)<\/span>/gi, '$1');

  // Remove empty p tags
  cleaned = cleaned.replace(/<p\s*>\s*<\/p>/gi, '');

  // Clean up multiple spaces and normalize whitespace
  cleaned = cleaned.replace(/\s+/g, ' ');
  cleaned = cleaned.replace(/>\s+</g, '><');

  return cleaned.trim();
}

export function sort(numArray) {
  return numArray.sort(function (a, b) {
    if (a > b) return 1;
    if (a < b) return -1;
    return 0;
  });
}

export function calcMiles(meters) {
  return meters * 0.000621371;
}

export function scrollTop(scrollToElement) {
  if (typeof window !== 'undefined') {
    // Use requestAnimationFrame for better performance and hydration compatibility
    requestAnimationFrame(() => {
      window.scroll({ top: 0, behavior: 'smooth' });
      if (scrollToElement !== undefined) {
        let element = document.getElementById(scrollToElement);
        if (element) element.focus();
      }
    });
  }
}
export function getStates() {
  return [
    {
      label: 'Alabama',
      value: 'AL',
    },
    {
      label: 'Alaska',
      value: 'AK',
    },
    {
      label: 'American Samoa',
      value: 'AS',
    },
    {
      label: 'Arizona',
      value: 'AZ',
    },
    {
      label: 'Arkansas',
      value: 'AR',
    },
    {
      label: 'California',
      value: 'CA',
    },
    {
      label: 'Colorado',
      value: 'CO',
    },
    {
      label: 'Connecticut',
      value: 'CT',
    },
    {
      label: 'Delaware',
      value: 'DE',
    },
    {
      label: 'District Of Columbia',
      value: 'DC',
    },
    {
      label: 'Florida',
      value: 'FL',
    },
    {
      label: 'Georgia',
      value: 'GA',
    },
    {
      label: 'Guam',
      value: 'GU',
    },
    {
      label: 'Hawaii',
      value: 'HI',
    },
    {
      label: 'Idaho',
      value: 'ID',
    },
    {
      label: 'Illinois',
      value: 'IL',
    },
    {
      label: 'Indiana',
      value: 'IN',
    },
    {
      label: 'Iowa',
      value: 'IA',
    },
    {
      label: 'Kansas',
      value: 'KS',
    },
    {
      label: 'Kentucky',
      value: 'KY',
    },
    {
      label: 'Louisiana',
      value: 'LA',
    },
    {
      label: 'Maine',
      value: 'ME',
    },
    {
      label: 'Maryland',
      value: 'MD',
    },
    {
      label: 'Massachusetts',
      value: 'MA',
    },
    {
      label: 'Michigan',
      value: 'MI',
    },
    {
      label: 'Minnesota',
      value: 'MN',
    },
    {
      label: 'Mississippi',
      value: 'MS',
    },
    {
      label: 'Missouri',
      value: 'MO',
    },
    {
      label: 'Montana',
      value: 'MT',
    },
    {
      label: 'Nebraska',
      value: 'NE',
    },
    {
      label: 'Nevada',
      value: 'NV',
    },
    {
      label: 'New Hampshire',
      value: 'NH',
    },
    {
      label: 'New Jersey',
      value: 'NJ',
    },
    {
      label: 'New Mexico',
      value: 'NM',
    },
    {
      label: 'New York',
      value: 'NY',
    },
    {
      label: 'North Carolina',
      value: 'NC',
    },
    {
      label: 'North Dakota',
      value: 'ND',
    },
    {
      label: 'Northern Mariana Islands',
      value: 'MP',
    },
    {
      label: 'Ohio',
      value: 'OH',
    },
    {
      label: 'Oklahoma',
      value: 'OK',
    },
    {
      label: 'Oregon',
      value: 'OR',
    },
    {
      label: 'Pennsylvania',
      value: 'PA',
    },
    {
      label: 'Puerto Rico',
      value: 'PR',
    },
    {
      label: 'Rhode Island',
      value: 'RI',
    },
    {
      label: 'South Carolina',
      value: 'SC',
    },
    {
      label: 'South Dakota',
      value: 'SD',
    },
    {
      label: 'Tennessee',
      value: 'TN',
    },
    {
      label: 'Texas',
      value: 'TX',
    },
    {
      label: 'Utah',
      value: 'UT',
    },
    {
      label: 'Vermont',
      value: 'VT',
    },
    {
      label: 'Virgin Islands',
      value: 'VI',
    },
    {
      label: 'Virginia',
      value: 'VA',
    },
    {
      label: 'Washington',
      value: 'WA',
    },
    {
      label: 'West Virginia',
      value: 'WV',
    },
    {
      label: 'Wisconsin',
      value: 'WI',
    },
    {
      label: 'Wyoming',
      value: 'WY',
    },
  ];
}

export function getNextOccurrenceDate(event) {
  if (!event) return null;

  // Use UTC to ensure consistent server/client rendering
  const today = new Date();
  const todayUTC = new Date(
    Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate())
  );

  // Support both camelCase (database) and lowercase (legacy JSON) field names
  const recurrenceStart =
    event.recurrenceDateStart || event.recurrencedatestart;
  const recurrenceEnd = event.recurrenceDateEnd || event.recurrencedateend;
  const dateEnd = event.dateEnd || event.dateend;
  const dateStart = event.dateStart || event.datestart || event.date;

  // For recurring events, check if we're within the recurrence period
  if (recurrenceStart && recurrenceEnd) {
    const recStart = new Date(recurrenceStart);
    const recEnd = new Date(recurrenceEnd);

    // If we're within the recurrence period, show "Now" or "Ongoing"
    if (todayUTC >= recStart && todayUTC <= recEnd) {
      return { type: 'ongoing', endDate: recEnd };
    }

    // If the recurrence hasn't started yet, show the start date
    if (todayUTC < recStart) {
      return { type: 'upcoming', date: recStart };
    }

    // If the recurrence has ended, return null (event shouldn't be shown)
    return null;
  }

  // For non-recurring events, check if the event is still ongoing
  if (dateEnd) {
    const eventEnd = new Date(dateEnd);
    if (todayUTC <= eventEnd) {
      // If event hasn't ended yet, show "Now" or the end date
      return { type: 'ongoing', endDate: eventEnd };
    }
  }

  // For single-day events or events that have ended
  if (dateStart) {
    const eventDate = new Date(dateStart);
    if (todayUTC <= eventDate) {
      return { type: 'upcoming', date: eventDate };
    }
  }

  return null;
}

export function formatEventDate(event) {
  const nextOccurrence = getNextOccurrenceDate(event);

  if (!nextOccurrence) return null;

  if (nextOccurrence.type === 'ongoing') {
    return {
      displayText: 'Now Until',
      subText: formatDate(nextOccurrence.endDate),
      isOngoing: true,
    };
  } else {
    return {
      displayText: getDateMonth(nextOccurrence.date),
      subText: getDateDay(nextOccurrence.date),
      isOngoing: false,
    };
  }
}

export function cleanParkData(park) {
  if (!park) return null;

  // Deep clone the park object to avoid mutating the original
  const cleanedPark = JSON.parse(JSON.stringify(park));

  // Recursively clean undefined values
  function cleanObject(obj) {
    if (obj === null || typeof obj !== 'object') return obj;

    if (Array.isArray(obj)) {
      return obj.map(cleanObject);
    }

    const cleaned = {};
    for (const [key, value] of Object.entries(obj)) {
      if (value === undefined) {
        cleaned[key] = null;
      } else if (typeof value === 'object' && value !== null) {
        cleaned[key] = cleanObject(value);
      } else {
        cleaned[key] = value;
      }
    }
    return cleaned;
  }

  return cleanObject(cleanedPark);
}

export function generateRecurringEventICS(event) {
  if (!event) return null;

  const {
    title,
    datestart,
    timestart,
    location,
    meetingpoint,
    parkfullname,
    isrecurring,
    recurrencedatestart,
    recurrencedateend,
    recurrencerule,
    times,
    id,
  } = event;

  // Helper function to format date for ICS
  const formatDateForICS = (date) => {
    return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
  };

  // Helper function to parse time string (e.g., "09:00 AM")
  const parseTimeString = (timeStr) => {
    if (!timeStr) return null;

    const timeMatch = timeStr.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
    if (!timeMatch) return null;

    let hours = parseInt(timeMatch[1]);
    const minutes = parseInt(timeMatch[2]);
    const period = timeMatch[3].toUpperCase();

    if (period === 'PM' && hours !== 12) hours += 12;
    if (period === 'AM' && hours === 12) hours = 0;

    return { hours, minutes };
  };

  // Helper function to create a date with time
  const createDateWithTime = (date, timeStr) => {
    const parsedTime = parseTimeString(timeStr);
    if (!parsedTime) return date;

    const newDate = new Date(date);
    newDate.setHours(parsedTime.hours, parsedTime.minutes, 0, 0);
    return newDate;
  };

  // Helper function to generate RRULE for different recurrence patterns
  const generateRRULE = (startDate, endDate, pattern = 'daily') => {
    const start = new Date(startDate);
    const end = new Date(endDate);

    switch (pattern) {
      case 'weekly':
        // For weekly events, we'll use UNTIL instead of COUNT for better compatibility
        return `RRULE:FREQ=WEEKLY;UNTIL=${formatDateForICS(end)}`;
      case 'monthly':
        return `RRULE:FREQ=MONTHLY;UNTIL=${formatDateForICS(end)}`;
      case 'yearly':
        return `RRULE:FREQ=YEARLY;UNTIL=${formatDateForICS(end)}`;
      case 'daily':
      default:
        // Calculate the number of days between start and end
        const daysDiff = Math.ceil((end - start) / (1000 * 60 * 60 * 24));
        return `RRULE:FREQ=DAILY;COUNT=${daysDiff + 1}`;
    }
  };

  // Helper function to detect recurrence pattern
  const detectRecurrencePattern = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const daysDiff = Math.ceil((end - start) / (1000 * 60 * 60 * 24));

    // If it's a very long period (more than 2 years), it's likely a yearly event
    if (daysDiff > 730) return 'yearly';
    // If it's more than 60 days, it's likely a monthly event
    if (daysDiff > 60) return 'monthly';
    // If it's more than 7 days, it's likely a weekly event
    if (daysDiff > 7) return 'weekly';
    // Otherwise, it's daily
    return 'daily';
  };

  // Build event details with both NPS.gov and ExploreNP links
  const exploreNPLink =
    typeof window !== 'undefined' ? window.location.href : '';
  const npsGovLink = id
    ? `https://www.nps.gov/planyourvisit/event-details.htm?id=${id}`
    : '';

  const eventDetails = [
    `What: ${title || 'Event'}`,
    `Where: ${location || meetingpoint || parkfullname || 'Check event details'}`,
    `View event on ExploreNP (not official or associated with NPS.gov): ${exploreNPLink}`,
    ...(npsGovLink
      ? [`Official Event Information from NPS.gov: ${npsGovLink}`]
      : []),
  ].join('\n\n');

  let icsEvents = [];

  if (isrecurring && recurrencedatestart && recurrencedateend) {
    // Handle recurring events
    const recurrenceStart = new Date(recurrencedatestart);
    const recurrenceEnd = new Date(recurrencedateend);

    // Parse recurrencerule if available, otherwise fall back to pattern detection
    let rrule = null;
    let parsedRule = null;
    if (recurrencerule) {
      // Use the actual recurrencerule from the event data
      parsedRule = parseRecurrenceRule(recurrencerule);
      rrule = `RRULE:${recurrencerule.split(';').slice(1).join(';')}`; // Remove DTSTART part
    } else {
      // Fall back to pattern detection for events without recurrencerule
      const pattern = detectRecurrencePattern(recurrenceStart, recurrenceEnd);
      rrule = generateRRULE(recurrenceStart, recurrenceEnd, pattern);
    }

    // Calculate effective date range (filter out past dates)
    const effectiveDates = getEffectiveDateRange(
      parsedRule,
      recurrencedatestart,
      recurrencedateend
    );
    const effectiveStart = effectiveDates.effectiveStart;
    const effectiveEnd = effectiveDates.effectiveEnd;

    // If effective start date is in the future, update the RRULE
    if (effectiveStart > recurrenceStart) {
      // Create new RRULE with updated start date
      const newStartDate = formatDateForICS(effectiveStart);
      if (rrule.includes('UNTIL=')) {
        // Replace UNTIL with new start date
        rrule = rrule.replace(/UNTIL=[^;]+/, `UNTIL=${newStartDate}`);
      } else {
        // Add new start date
        rrule = `${rrule};DTSTART=${newStartDate}`;
      }
    }

    // Get all time slots for this event
    const timeSlots = times && Array.isArray(times) ? times : [];

    // If no time slots are provided or selected, return null
    if (timeSlots.length === 0) {
      return null;
    }

    if (timeSlots.length > 0) {
      // Create events for each time slot with RRULE
      timeSlots.forEach((timeSlot, index) => {
        const { timestart: slotStart, timeend: slotEnd } = timeSlot;

        const eventStart = createDateWithTime(effectiveStart, slotStart);
        const eventEnd = slotEnd
          ? createDateWithTime(effectiveStart, slotEnd)
          : new Date(eventStart.getTime() + 2 * 60 * 60 * 1000); // Default 2 hours

        icsEvents.push({
          start: eventStart,
          end: eventEnd,
          summary: `${title || 'Event'}${timeSlots.length > 1 ? ` (${slotStart})` : ''}`,
          description: eventDetails,
          location: location || meetingpoint || parkfullname || '',
          url: exploreNPLink,
          rrule: rrule,
        });
      });
    } else {
      // No specific time slots, create daily events with RRULE
      const eventStart = createDateWithTime(
        effectiveStart,
        timestart || '09:00 AM'
      );
      const eventEnd = new Date(eventStart.getTime() + 2 * 60 * 60 * 1000); // 2 hours later

      icsEvents.push({
        start: eventStart,
        end: eventEnd,
        summary: title || 'Event',
        description: eventDetails,
        location: location || meetingpoint || parkfullname || '',
        url: exploreNPLink,
        rrule: rrule,
      });
    }
  } else {
    // Handle single events
    const startDate = datestart ? new Date(datestart) : new Date();
    const eventStart = createDateWithTime(startDate, timestart || '09:00 AM');
    const eventEnd = new Date(eventStart.getTime() + 2 * 60 * 60 * 1000); // 2 hours later

    icsEvents.push({
      start: eventStart,
      end: eventEnd,
      summary: title || 'Event',
      description: eventDetails,
      location: location || meetingpoint || parkfullname || '',
      url: exploreNPLink,
    });
  }

  // Create .ics file content
  const icsContent = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//National Parks//Event Calendar//EN',
    ...icsEvents
      .map((event) => [
        'BEGIN:VEVENT',
        `DTSTART:${formatDateForICS(event.start)}`,
        `DTEND:${formatDateForICS(event.end)}`,
        `SUMMARY:${event.summary}`,
        `DESCRIPTION:${event.description}`,
        `LOCATION:${event.location}`,
        `URL:${event.url}`,
        ...(event.rrule ? [`${event.rrule}`] : []),
        'END:VEVENT',
      ])
      .flat(),
    'END:VCALENDAR',
  ].join('\r\n');

  return icsContent;
}

export function getEventCalendarSummary(event, selectedTimeSlots = null) {
  if (!event) return null;

  const {
    title,
    isrecurring,
    recurrencedatestart,
    recurrencedateend,
    recurrencerule,
    times,
  } = event;

  if (!isrecurring) {
    return {
      type: 'single',
      summary: 'Single event can be added to your calendar',
    };
  }

  if (!recurrencedatestart || !recurrencedateend) {
    return {
      type: 'single',
      summary: 'Single event can be added to your calendar',
    };
  }

  const startDate = new Date(recurrencedatestart);
  const endDate = new Date(recurrencedateend);
  const daysDiff = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));

  const timeSlots = times && Array.isArray(times) ? times : [];

  // If specific time slots are selected, use those
  const effectiveTimeSlots = selectedTimeSlots
    ? selectedTimeSlots.length
    : timeSlots.length;
  const totalEvents =
    effectiveTimeSlots > 0 ? daysDiff * effectiveTimeSlots : daysDiff;

  // Use parsed recurrencerule if available, otherwise fall back to pattern detection
  let pattern = 'daily';
  if (recurrencerule) {
    const parsedRule = parseRecurrenceRule(recurrencerule);
    if (parsedRule && parsedRule.frequency) {
      pattern = parsedRule.frequency;
    }
  } else {
    // Fall back to pattern detection based on date range
    if (daysDiff > 730) pattern = 'yearly';
    else if (daysDiff > 60) pattern = 'monthly';
    else if (daysDiff > 7) pattern = 'weekly';
  }

  return {
    type: 'recurring',
    pattern,
    totalEvents,
    timeSlots: effectiveTimeSlots,
    startDate: recurrencedatestart,
    endDate: recurrencedateend,
    summary: `${totalEvents} event${totalEvents > 1 ? 's' : ''} can be added to your calendar`,
  };
}

/**
 * Parse iCalendar RRULE string to extract recurrence information
 * @param {string} recurrencerule - The RRULE string from event data
 * @returns {object} Parsed recurrence information
 */
export function parseRecurrenceRule(recurrencerule) {
  if (!recurrencerule) return null;

  try {
    const rule = {};

    // Split the rule into parts
    const parts = recurrencerule.split(';');

    parts.forEach((part) => {
      if (part.includes('=')) {
        const [key, value] = part.split('=');
        rule[key] = value;
      }
    });

    // Parse frequency
    if (rule.FREQ) {
      rule.frequency = rule.FREQ.toLowerCase();
    }

    // Parse interval
    if (rule.INTERVAL) {
      rule.interval = parseInt(rule.INTERVAL) || 1;
    }

    // Parse byday (days of week)
    if (rule.BYDAY) {
      rule.byDay = rule.BYDAY.split(',').map((day) => {
        const dayMap = {
          MO: 'Monday',
          TU: 'Tuesday',
          WE: 'Wednesday',
          TH: 'Thursday',
          FR: 'Friday',
          SA: 'Saturday',
          SU: 'Sunday',
        };
        return dayMap[day] || day;
      });
    }

    // Parse bymonthday (day of month)
    if (rule.BYMONTHDAY) {
      rule.byMonthDay = parseInt(rule.BYMONTHDAY);
    }

    // Parse bysetpos (position in set - 1st, 2nd, 3rd, 4th, last)
    if (rule.BYSETPOS) {
      rule.bySetPos = parseInt(rule.BYSETPOS);
    }

    // Parse until date
    if (rule.UNTIL) {
      rule.until = new Date(
        rule.UNTIL.replace(
          /(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})Z/,
          '$1-$2-$3T$4:$5:$6Z'
        )
      );
    }

    // Parse count
    if (rule.COUNT) {
      rule.count = parseInt(rule.COUNT);
    }

    return rule;
  } catch (error) {
    console.error('Error parsing recurrence rule:', error);
    return null;
  }
}

/**
 * Generate human-readable description of recurrence pattern
 * @param {object} parsedRule - Parsed recurrence rule
 * @returns {string} Human-readable description
 */
export function getHumanReadableRecurrence(parsedRule) {
  if (!parsedRule) return 'Recurring Event';

  const { frequency, interval, byDay, byMonthDay, bySetPos } = parsedRule;

  let description = '';

  // Handle frequency and interval
  if (!frequency) {
    return 'Recurring Event';
  }

  if (interval > 1) {
    // Convert frequency to proper plural form for intervals
    const frequencyPlural = getFrequencyPlural(frequency, interval);
    description += `Every ${interval} ${frequencyPlural}`;
  } else {
    description += frequency.charAt(0).toUpperCase() + frequency.slice(1);
  }

  // Handle specific days
  if (byDay && byDay.length > 0) {
    if (bySetPos) {
      const positionMap = {
        1: 'first',
        2: 'second',
        3: 'third',
        4: 'fourth',
        '-1': 'last',
      };
      const position = positionMap[bySetPos] || bySetPos;
      description += ` on the ${position} ${byDay[0]}`;
    } else if (byDay.length === 1) {
      description += ` on ${byDay[0]}s`;
    } else if (byDay.length === 7) {
      // All seven days of the week - use "Daily" instead of listing all days
      description = description.replace(/Weekly|Every \d+ weeks/, 'Daily');
      if (interval > 1) {
        description = `Every ${interval} days`;
      }
    } else {
      description += ` on ${byDay.join(', ')}s`;
    }
  }

  // Handle specific day of month
  if (byMonthDay) {
    description += ` on the ${byMonthDay}${getOrdinalSuffix(byMonthDay)}`;
  }

  return description;
}

/**
 * Get proper plural form for frequency words when used with intervals
 * @param {string} frequency - The frequency (daily, weekly, monthly, yearly)
 * @param {number} interval - The interval number
 * @returns {string} Proper plural form
 */
function getFrequencyPlural(frequency, interval) {
  if (interval === 1) return frequency;

  switch (frequency) {
    case 'daily':
      return interval === 1 ? 'day' : 'days';
    case 'weekly':
      return interval === 1 ? 'week' : 'weeks';
    case 'monthly':
      return interval === 1 ? 'month' : 'months';
    case 'yearly':
      return interval === 1 ? 'year' : 'years';
    default:
      return frequency;
  }
}

/**
 * Get ordinal suffix for numbers (1st, 2nd, 3rd, etc.)
 * @param {number} num - The number
 * @returns {string} Ordinal suffix
 */
function getOrdinalSuffix(num) {
  const j = num % 10;
  const k = num % 100;
  if (j === 1 && k !== 11) return 'st';
  if (j === 2 && k !== 12) return 'nd';
  if (j === 3 && k !== 13) return 'rd';
  return 'th';
}

/**
 * Calculate event duration in minutes from start and end times
 * @param {string} startTime - Start time string (e.g., "09:00 AM")
 * @param {string} endTime - End time string (e.g., "12:00 PM")
 * @returns {number} Duration in minutes
 */
export function calculateEventDuration(startTime, endTime) {
  if (!startTime || !endTime) return null;

  try {
    const parseTime = (timeStr) => {
      const timeMatch = timeStr.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
      if (!timeMatch) return null;

      let hours = parseInt(timeMatch[1]);
      const minutes = parseInt(timeMatch[2]);
      const period = timeMatch[3].toUpperCase();

      if (period === 'PM' && hours !== 12) hours += 12;
      if (period === 'AM' && hours === 12) hours = 0;

      return hours * 60 + minutes;
    };

    const startMinutes = parseTime(startTime);
    const endMinutes = parseTime(endTime);

    if (startMinutes === null || endMinutes === null) return null;

    let duration = endMinutes - startMinutes;

    // Handle overnight events
    if (duration < 0) {
      duration += 24 * 60; // Add 24 hours
    }

    return duration;
  } catch (error) {
    console.error('Error calculating event duration:', error);
    return null;
  }
}

/**
 * Format duration in human-readable format
 * @param {number} durationMinutes - Duration in minutes
 * @returns {string} Formatted duration
 */
export function formatDuration(durationMinutes) {
  if (!durationMinutes || durationMinutes <= 0) return '';

  const hours = Math.floor(durationMinutes / 60);
  const minutes = durationMinutes % 60;

  if (hours === 0) {
    return `${minutes} minute${minutes !== 1 ? 's' : ''}`;
  } else if (minutes === 0) {
    return `${hours} hour${hours !== 1 ? 's' : ''}`;
  } else {
    return `${hours} hour${hours !== 1 ? 's' : ''} ${minutes} minute${minutes !== 1 ? 's' : ''}`;
  }
}

/**
 * Calculate the next occurrence date based on recurrence rules
 * @param {object} parsedRule - Parsed recurrence rule
 * @param {Date} originalStartDate - Original start date from event
 * @param {Date} today - Today's date (defaults to current date)
 * @returns {Date} Next occurrence date
 */
export function calculateNextOccurrenceDate(
  parsedRule,
  originalStartDate,
  today = new Date()
) {
  if (!parsedRule || !originalStartDate) return null;

  try {
    const startDate = new Date(originalStartDate);
    const currentDate = new Date(today);

    // If the original start date is in the future, use it
    if (startDate > currentDate) {
      return startDate;
    }

    const { frequency, interval = 1, byDay, byMonthDay, bySetPos } = parsedRule;

    let nextDate = new Date(startDate);

    // Keep advancing the date until we find a future date
    while (nextDate <= currentDate) {
      switch (frequency) {
        case 'daily':
          nextDate.setDate(nextDate.getDate() + interval);
          break;

        case 'weekly':
          if (byDay && byDay.length > 0) {
            // Find next occurrence of specified day(s)
            const currentDay = nextDate.getDay();
            const targetDays = byDay
              .map((day) => {
                const dayMap = {
                  MO: 1,
                  TU: 2,
                  WE: 3,
                  TH: 4,
                  FR: 5,
                  SA: 6,
                  SU: 0,
                };
                return dayMap[day] || 0;
              })
              .sort((a, b) => a - b);

            // Find next target day
            let nextTargetDay = targetDays.find((day) => day > currentDay);
            if (!nextTargetDay) {
              // Next occurrence is next week
              nextTargetDay = targetDays[0];
              nextDate.setDate(
                nextDate.getDate() + (7 - currentDay + nextTargetDay)
              );
            } else {
              nextDate.setDate(
                nextDate.getDate() + (nextTargetDay - currentDay)
              );
            }
          } else {
            nextDate.setDate(nextDate.getDate() + 7 * interval);
          }
          break;

        case 'monthly':
          if (bySetPos && byDay && byDay.length > 0) {
            // Handle "nth day of month" (e.g., 2nd Thursday)
            const targetDay = byDay[0];
            const dayMap = { MO: 1, TU: 2, WE: 3, TH: 4, FR: 5, SA: 6, SU: 0 };
            const targetDayNum = dayMap[targetDay];

            // Move to next month
            nextDate.setMonth(nextDate.getMonth() + interval);
            nextDate.setDate(1);

            // Find the nth occurrence of the target day
            let occurrenceCount = 0;
            let currentDate = new Date(nextDate);

            while (currentDate.getMonth() === nextDate.getMonth()) {
              if (currentDate.getDay() === targetDayNum) {
                occurrenceCount++;
                if (occurrenceCount === bySetPos) {
                  nextDate = new Date(currentDate);
                  break;
                }
              }
              currentDate.setDate(currentDate.getDate() + 1);
            }
          } else if (byMonthDay) {
            // Handle specific day of month
            nextDate.setMonth(nextDate.getMonth() + interval);
            nextDate.setDate(byMonthDay);
          } else {
            nextDate.setMonth(nextDate.getMonth() + interval);
          }
          break;

        case 'yearly':
          if (byMonthDay) {
            // Handle specific month and day
            nextDate.setFullYear(nextDate.getFullYear() + interval);
          } else {
            nextDate.setFullYear(nextDate.getFullYear() + interval);
          }
          break;

        default:
          nextDate.setDate(nextDate.getDate() + 1);
          break;
      }
    }

    return nextDate;
  } catch (error) {
    console.error('Error calculating next occurrence date:', error);
    return new Date(today);
  }
}

/**
 * Filter out past dates and calculate effective start date for recurring events
 * @param {object} parsedRule - Parsed recurrence rule
 * @param {string} originalStartDate - Original start date string
 * @param {string} originalEndDate - Original end date string
 * @param {Date} today - Today's date (defaults to current date)
 * @returns {object} Filtered date range with effective start and end dates
 */
export function getEffectiveDateRange(
  parsedRule,
  originalStartDate,
  originalEndDate,
  today = new Date()
) {
  if (!parsedRule || !originalStartDate) {
    return {
      effectiveStart: today,
      effectiveEnd: originalEndDate ? new Date(originalEndDate) : null,
    };
  }

  try {
    const originalStart = new Date(originalStartDate);
    const originalEnd = originalEndDate ? new Date(originalEndDate) : null;
    const currentDate = new Date(today);

    // Calculate effective start date (next occurrence)
    let effectiveStart = calculateNextOccurrenceDate(
      parsedRule,
      originalStart,
      currentDate
    );

    // If we couldn't calculate a next occurrence, use today
    if (!effectiveStart || effectiveStart <= currentDate) {
      effectiveStart = new Date(currentDate);
    }

    // For end date, if original end is in the past, extend it
    let effectiveEnd = originalEnd;
    if (originalEnd && originalEnd <= currentDate) {
      // Extend end date by 1 year from today
      effectiveEnd = new Date(currentDate);
      effectiveEnd.setFullYear(effectiveEnd.getFullYear() + 1);
    }

    return {
      effectiveStart,
      effectiveEnd,
      originalStart,
      originalEnd,
      hasDateShift: effectiveStart > originalStart,
    };
  } catch (error) {
    console.error('Error calculating effective date range:', error);
    return { effectiveStart: today, effectiveEnd: null };
  }
}

export function generateEventStructuredData(event) {
  if (!event || !event.title) return null;

  // Extract event data with safe defaults
  const {
    title = '',
    description = '',
    datestart = '',
    dateend = '',
    times = {},
    timestart = '',
    timeend = '',
    feeinfo = '',
    regresurl = '',
    infourl = '',
    contactemailaddress = '',
    contactphonenumber = '',
    contactname = '',
    location = '',
    meetingpoint = '',
    latitude = '',
    longitude = '',
    isregresrequired = '',
    isrecurring = '',
    recurrencedatestart = '',
    recurrencedateend = '',
    parkfullname = '',
    parkCode = '',
    images: eventImages = [],
    category = '',
    types = [],
  } = event;

  // Helper function to clean HTML from description
  const cleanDescription = (html) => {
    if (!html) return '';
    return html.replace(/<[^>]*>/g, '').trim();
  };

  // Helper function to convert AM/PM time to 24-hour format (HH:MM)
  const convertTimeTo24Hour = (timeStr) => {
    if (!timeStr) return null;

    const timeMatch = timeStr.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
    if (!timeMatch) return null;

    let hours = parseInt(timeMatch[1]);
    const minutes = parseInt(timeMatch[2]);
    const period = timeMatch[3].toUpperCase();

    if (period === 'PM' && hours !== 12) hours += 12;
    if (period === 'AM' && hours === 12) hours = 0;

    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  };

  // Build the structured data object
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Event',
    name: title,
    description: cleanDescription(description),
    eventStatus: 'https://schema.org/EventScheduled',
    eventAttendanceMode: 'https://schema.org/OfflineEventAttendanceMode',
  };

  // Add dates and times using NPS.gov style structure
  if (datestart) {
    structuredData.startDate = datestart; // Just the date YYYY-MM-DD
  }

  if (dateend) {
    structuredData.endDate = dateend; // Just the date YYYY-MM-DD
  }

  // Add times separately if available
  if (timestart || timeend) {
    structuredData.eventSchedule = {
      '@type': 'Schedule',
    };

    if (datestart) {
      structuredData.eventSchedule.startDate = datestart;
    }

    if (dateend) {
      structuredData.eventSchedule.endDate = dateend;
    }

    if (timestart) {
      // Convert AM/PM to 24-hour format for startTime
      const startTime = convertTimeTo24Hour(timestart);
      if (startTime) {
        structuredData.eventSchedule.startTime = startTime;
      }
    }

    if (timeend) {
      // Convert AM/PM to 24-hour format for endTime
      const endTime = convertTimeTo24Hour(timeend);
      if (endTime) {
        structuredData.eventSchedule.endTime = endTime;
      }
    }
  }

  // Add location information
  if (parkfullname || location || meetingpoint || (latitude && longitude)) {
    const locationData = {
      '@type': 'Place',
      name: parkfullname || 'National Park Event Location',
    };

    // Always add address structure if we have park information
    if (parkfullname) {
      const parkParts = parkfullname.split(',').map((part) => part.trim());
      locationData.address = {
        '@type': 'PostalAddress',
        addressLocality: parkParts[0] || '',
        addressRegion: parkParts.slice(1).join(', ') || '',
        addressCountry: 'US',
      };
    }

    if (latitude && longitude) {
      locationData.geo = {
        '@type': 'GeoCoordinates',
        latitude: parseFloat(latitude),
        longitude: parseFloat(longitude),
      };
    }

    structuredData.location = locationData;
  }

  // Add organizer information
  if (contactname || contactemailaddress || contactphonenumber) {
    const organizer = {
      '@type': 'Organization',
      name: contactname || 'National Park Service',
    };

    if (contactemailaddress) {
      organizer.email = contactemailaddress;
    }

    if (contactphonenumber) {
      organizer.telephone = contactphonenumber;
    }

    structuredData.organizer = organizer;
  }

  // Add images
  if (eventImages && eventImages.length > 0) {
    const imageUrls = eventImages
      .filter((img) => img?.url)
      .map((img) => {
        if (img.url.startsWith('/')) {
          return `https://www.nps.gov${img.url}`;
        }
        return img.url;
      });

    if (imageUrls.length > 0) {
      structuredData.image = imageUrls;
    }
  }

  // Add offers (tickets/registration)
  if (regresurl || feeinfo) {
    const offer = {
      '@type': 'Offer',
      priceCurrency: 'USD',
      availability:
        isregresrequired === 'true'
          ? 'https://schema.org/LimitedAvailability'
          : 'https://schema.org/InStock',
    };

    if (regresurl) {
      offer.url = regresurl;
    }

    if (feeinfo && feeinfo.includes('$')) {
      offer.price = feeinfo;
    }

    structuredData.offers = offer;
  }

  // Add additional properties
  // Combine category and types into keywords for better categorization
  const allKeywords = [];

  if (
    category &&
    category.trim() &&
    category.trim().toLowerCase() !== 'unspecified'
  ) {
    allKeywords.push(category.trim());
  }

  if (types && types.length > 0) {
    allKeywords.push(...types);
  }

  if (allKeywords.length > 0) {
    structuredData.keywords = allKeywords.join(', ');
  }

  // Add duration property (empty for now, but follows NPS.gov structure)
  structuredData.duration = '';

  // Handle recurring events - update existing eventSchedule if present
  if (isrecurring === 'true') {
    if (!structuredData.eventSchedule) {
      structuredData.eventSchedule = {
        '@type': 'Schedule',
      };
    }

    if (recurrencedatestart) {
      structuredData.eventSchedule.startDate = recurrencedatestart;
    }

    if (recurrencedateend) {
      structuredData.eventSchedule.endDate = recurrencedateend;
    }
  }

  // Add URL to the event
  if (event.slug) {
    structuredData.url = `https://explorenp.com/event/${event.slug}`;
  }

  return structuredData;
}
